import { createSlice } from '@reduxjs/toolkit';
import { SCR_COMPETITION } from '../enums';

const navigationState = createSlice({
  name: 'navigation',
  initialState: SCR_COMPETITION,
  reducers: {
    setCurrentPage(state, action) {
      return action.payload;
    }
  }
});

export const { setCurrentPage } = navigationState.actions;
export default navigationState.reducer;